<template>
  <div class="tests">
    <header>
      <div class="search">
        <UIcon name="search" />
        <input type="text" v-model="search" placeholder="Поиск по тестам" />
      </div>
    </header>

    <div class="list">
      <router-link
        to="/test/0"
        class="test-card create"
      >
        <feather-icon
          size="35"
          icon="PlusCircleIcon"
          class="icon"
        />
        <div class="title">Добавить тест</div>
      </router-link>

      <TestCard v-for="(test, index) of tests" :key="index" :test="test" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TestCard from "@/components/redesign/tests/TestCard";

export default {
  name: 'Tests',
  components: { TestCard },
    data() {
    return {
      search: '',
    };
  },
  computed: {
    ...mapState('courses', ['tests']),
  },
  methods: {
    ...mapActions('courses', ['getTests']),
  },
  async mounted() {
    await this.getTests();
  },
};
</script>

<style lang="scss">
.tests {
  width: 100%;

  header {
    margin-bottom: 24px;

    .search {
      display: flex;
      align-items: center;
      padding: 0 16px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 8px;
      width: 100%;

      .icon {
        fill: #A9A9A9;
        margin-right: 24px;
      }

      input {
        height: 100%;
        padding: 0;
        border: none;
        font-size: 16px;
      }
    }
  }

  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;

    .test-card {
      width: 100%;
      min-height: 160px;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0px 12px 13px rgba(197, 197, 197, 0.25);
      }
      
      &.create {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 16px;
        font-weight: 500;

        .title {
          margin-top: 10px;
          color: var(--primary);
        }

        .icon {
          color: var(--primary);
        }
      }
    }
  }
}
</style>